import { render, staticRenderFns } from "./MdtMultiselect.vue?vue&type=template&id=0f641276&scoped=true"
import script from "./MdtMultiselect.vue?vue&type=script&lang=js"
export * from "./MdtMultiselect.vue?vue&type=script&lang=js"
import style0 from "./MdtMultiselect.vue?vue&type=style&index=0&id=0f641276&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f641276",
  null
  
)

export default component.exports